// import '../../node_modules/flickity/dist/flickity.pkgd.js';
import Flickity from 'flickity';

/* eslint-disable no-unused-vars, no-undef */
( function() {
	let carousels = document.querySelectorAll( '.carousel-cards' );
	let len = carousels.length;
	if ( ! len ) {
		return;
	}

	for ( let i = 0; i < len; i++ ) {
		new Flickity( carousels[i], {
			//freeScroll: true,
			groupCells: true,
			prevNextButtons: true,
			pageDots: false,
			cellAlign: 'left',
			contain: true,
			percentPosition: true,
			//wrapAround: true
		} );
	}
} )();

( function() {
	let el = document.querySelector( '.timeline' );
	if ( ! el ) return;
	new Flickity( el, {
		//freeScroll: true,
		groupCells: true,
		prevNextButtons: true,
		pageDots: false,
		cellAlign: 'left',
		contain: true,
		percentPosition: true,
		//wrapAround: true
	} );
} )();
/* eslint-enable no-unused-vars, no-undef */
